import { map, prop, find, compose, pathEq, path } from 'ramda';

const ContentBlok = (blok, rels) => {
  if (blok.type)
    blok.type = rels.find((rel) => rel.content.article_type === blok.type);

  if (blok.category)
    blok.category = rels.find((rel) => rel.content.category === blok.category);

  if (blok.type_filter?.length)
    blok.type_filter = compose(
      path(['content', 'title']),
      find(pathEq(blok.type_filter, ['content', 'article_type']))
    )(rels)

  if (blok.category_filter?.length)
    blok.category_filter = compose(
      path(['content', 'title']),
      find(pathEq(blok.category_filter, ['content', 'category']))
    )(rels)

  if (blok.button_link)
    blok.button_link.rel = rels.find((rel) => rel.uuid === blok.button_link.id);

  return blok;
};

const Homepage = (data) => ({
  ...data.story,
  content: {
    ...data.story.content,
    body: data.story.content.body.map((blok) => ContentBlok(blok, data.rels)),
    ads: map(prop('content'), data.adv || {})
  },
});

export { Homepage };
